import React, { useState, useEffect } from "react";
import { getModulos } from "../../services/modulosService";
import { toastTimeout } from "../utils/toasts";
import { useAuth } from "../../AuthContext";
import { useHistory } from "react-router-dom";

export default function Main(props) {
  const [mounted, setMounted] = useState(false);
  const [modulos, setModulos] = useState([]);
  const [willRedirect, setWillRedirect] = useState(true);
  const { activeUser: user, clearModule, setModule } = useAuth();
  const history = useHistory();

  const fetchUserAndModulos = async () => {
    const modulos = await getModulos();
    if (modulos) {
      setModulos(modulos);
      let count = 0;
      let indexModuloUnico = null;
      modulos.map((modulo, index) => {
        if (user.empresa.modulos.find((item) => item === modulo._id)) {
          count++;
          indexModuloUnico = index;
        }
      });
      if (count === 1 && !user.empresa.muestraModulosInactivos) {
        setModule(modulos[indexModuloUnico].path);
        redirectToModulo(modulos[indexModuloUnico].path);
      } else setWillRedirect(false);
    } else history.replace("/noconnection");
  };

  useEffect(() => {
    if (!mounted) {
      clearModule();
      fetchUserAndModulos();
    }
    setMounted(true);
  }, []);

  const redirectToModulo = (path) => {
    setModule(path);
    history.push("/" + path);
  };

  const goModulo = (index) => {
    history.push(modulos[index].path);
  };

  const moduloNoHabilitado = () => {
    toastTimeout("Módulo No Habilitado", "Su empresa no tiene habilitado este módulo", 5000, true, "error", () => {});
  };

  return !willRedirect ? (
    <div>
      {/* Content Header (Page header) */}
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1 className="m-0">Seleccione Módulo</h1>
            </div>
            {/* /.col */}
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item active">
                  <a href="#">Inicio</a>
                </li>
              </ol>
            </div>
            {/* /.col */}
          </div>
          {/* /.row */}
        </div>
        {/* /.container-fluid */}
      </div>
      {/* /.content-header */}

      <section className="content">
        <div className="container-fluid">
          <h5 className="mb-2 mt-4">Módulos</h5>
          <div className="row">
            {modulos &&
              modulos.map((modulo, index) => {
                if (user.empresa.modulos.find((item) => item === modulo._id)) {
                  return (
                    <div key={"modulo" + index} className="col-lg-3 col-6">
                      <div className={"small-box " + modulo.color}>
                        <div className="inner">
                          <h3>{modulo.nombre}</h3>

                          <p>{modulo.descripcion}</p>
                        </div>
                        <div className="icon">
                          <i className={modulo.icon}></i>
                        </div>
                        <a className="small-box-footer clickable" onClick={() => goModulo(index)}>
                          Ingresar <i className="fas fa-arrow-circle-right"></i>
                        </a>
                      </div>
                    </div>
                  );
                } else {
                  if (user.empresa.muestraModulosInactivos) {
                    return (
                      <div key={"modulo" + index} className="col-lg-3 col-6">
                        <div className={"small-box bg-light"}>
                          <div className="inner">
                            <h3>{modulo.nombre}</h3>

                            <p>{modulo.descripcion}</p>
                          </div>
                          <div className="icon">
                            <i className={modulo.icon}></i>
                          </div>
                          <a className="small-box-footer clickable" onClick={() => moduloNoHabilitado(index)}>
                            Ingresar <i className="fas fa-arrow-circle-right"></i>
                          </a>
                        </div>
                      </div>
                    );
                  }
                }
              })}
          </div>
        </div>
      </section>
    </div>
  ) : (
    ""
  );
}
